// extracted by mini-css-extract-plugin
module.exports = {"helpModalWrap":"vEeZs","header":"_2Nf6k","heading":"_3AkgI","inputNumber":"_2pgjn","languageDropdownWrap":"_3x46l","textarea":"_18iJS"};